import { NodeModel } from "../_model/NodeModel";
import { DecorationInputCorn } from "./decorationInputCorn"
import { Types } from "../../utils/nodeTypes"
import Properties from "../_model/ModelEngineeringProperties";

class InputCorn extends NodeModel {
    constructor() {
        super("InputCorn");

        this.connectionPack = new Array();
        this.type = new Types().InputCorn;
        this.value = "0,00";
        this.x = 0;
        this.y = 0;
        this.xRect = () => this.x + (this.width - this.widthRect) / 2;
        this.yRect = () => this.y + this.height - 28;
        this.xDot = (event) => (event ? event.x : this.x) + this.width - 18;
        this.yDot = (event) => (event ? event.y : this.y) + this.height - 38;
        this.xText = () => this.xRect() + (this.widthRect / 2);
        this.yText = () => this.yRect() + 15;
        this.height = 120;
        this.width = 90;
        this.heightRect = 20;
        this.widthRect = 60;
        this.heightText = this.heightRect - 5;
        this.heightImg = 90;
        this.widthImg = 80;
        this.srcImg = require("@/assets/Fluxogramas/Corn.png");
        this.data = [new Properties({...this, value: "0.00", height: 0, observation:"input", key: "W" })]
        this.showBox = true
        this.showStraw = false
        this.proportionOfSugars = "4:2:1:1:0"


        this.decorate = async function(callback) {
            this.decorator = new DecorationInputCorn();
            await this.decorator.init(this, callback)
        };

        this.update = async (nodeEdited) => {
            
            this.showStraw = nodeEdited.showStraw
            this.proportionOfSugars = nodeEdited.proportionOfSugars;

            if (nodeEdited.attrs) {
                this.data = nodeEdited.attrs.map((p) => {
                    console.log(`${p.key}>${p.propName}>${p.key}`,p.value)
                    return new Properties({...p, isInput: true, caption: '', unit: '' })
            })
            }

            let moagem = this.data.find(a => a.key == "W" && a.observation)
            let valueLenght = moagem ? moagem.value.length : 0
            let lenghtOfFont = valueLenght * 9
            this.widthRect = lenghtOfFont > this.widthRect ? lenghtOfFont : this.widthRect;
            this.decorator.setTextAndAdjustWidth()
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.connectionPack = node.connectionPack
            this.widthImg = node.widthImg
            this.value = node.value;
            this.widthRect = node.widthRect;
            this.heightRect = node.heightRect
            this.showBox = node.showBox
            this.showStraw = node.showStraw
            this.proportionOfSugars = node.proportionOfSugars
            this.data = node.data.map(d => new Properties({...d }));
        }

        this.clone = () => {
            let cloned = new InputCorn();
            cloned.id = this.id
            cloned.idName = this.idName
            cloned.type = this.type
            cloned.connectionPack = this.connectionPack.map(c => ({ conn: {...c.conn,  decorator: null}, dot: c.dot }));
            cloned.width = this.width;
            cloned.value = this.value;
            cloned.widthRect = this.widthRect;
            cloned.valueRect = this.valueRect;
            cloned.showBox = this.showBox
            cloned.showStraw = this.showStraw
            cloned.proportionOfSugars = this.proportionOfSugars
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible
            cloned.data = this.data.map(d => d.clone());
            cloned.x = this.x;
            cloned.y = this.y;

            return cloned
        }

        this.removeConnection = (connectionId) => {
            this.connectionPack = this.connectionPack.filter(connection => connection.conn.id != connectionId)
        }

        this.applyProperties = () => {
            
        }
    }
}


export { InputCorn };